<style lang="scss" scoped>
.search-input {
    width: 300px;
    @media only screen and (max-width: 576px) {
        width: 100%;
    }
}
</style>

<template>
    <div class="px-lg-60">
        <div class="row mb-32 mb-md-60 pt-32">
            <div class="col-12 d-flex justify-content-between flex-wrap">
                <div class="d-flex flex-column mb-32 mb-lg-0">
                    <span>{{ $t('pages.tips.intro') }}</span>
                    <span>{{ $t('pages.tips.intro_2') }}</span>
                </div>
                <form action="/search" @submit.prevent="submit" class="search-input">
                    <el-input ref="searchInput" v-model="search" class="small mb-0" type="text" :name="$t('pages.tips.search')" :placeholder="$t('pages.tips.search')" :hasLabel="false"></el-input>
                </form>
            </div>
        </div>
        <masonry v-if="filteredTips.length > 0" :cols="{ default: 4, 1440: 3, 700: 2, 400: 1 }" :gutter="{default: '48px', 700: '16px'}">
            <card-tip v-for="(tip, index) in filteredTips" :key="index" :data="tip" :disabled="tip.locked"></card-tip>
        </masonry>
        <div v-else>
            <h4 class="text-primary fw-b text-center mb-8">{{ $t('pages.tips.no_tips_found_title') }}</h4>
            <p class="text-center">{{ $t('pages.tips.no_tips_found', { search: search }) }}</p>
        </div>
    </div>
</template>

<script>
import { CardTip } from '@/components/cards'
import { ElInput } from '@/components/forms'

export default {
    name: 'tips',
    components: { CardTip, ElInput },
    data: () => ({
        search: '',
        type: 'dayshift'
    }),

    mounted() {
        this.$store.dispatch('tips/readUserTips', this.currentUser.user.id)
    },
    methods: {
        submit: function () {
            this.$refs.searchInput.$el.querySelector('input').blur()
        }
    },
    computed: {
        filteredTips() {
            if (!this.$store.getters[`tips/all`]) return []


            return this._.orderBy(this.$store.getters[`tips/all`].filter(tip => {
                return tip.title.toLowerCase().includes(this.search.toLowerCase()) ||
                    tip.tip_categories.filter(tag => tag.toLowerCase().includes(this.search.toLowerCase())).length > 0
            }), 'day')
        },

        currentUser() {
            return this.$store.getters['user/currentUser']
        }
    }
}
</script>
